import * as Yup from 'yup';

export const PHONE_REGEX = /^[+]{1}[0-9\\s.\\/-]{4,17}$/;

export const getPhoneValidator = () =>
  Yup.string().strict(true).matches(PHONE_REGEX, 'Enter valid phone. Example +123456789');
